<template>
  <div class="columns box">
    <div class="notification page-integrations__notification--is-warning">
      <sc-icon icon="search" />
      Nenhum aplicativo encontrado para integração
    </div>
  </div>
</template>

<script>
import { ScIcon } from '@intelipost-js/secure-components';

export default {
  name: 'integration-self-service-empty-list',

  components: {
    ScIcon,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {

  &__notification {
    &--is-warning {
      font-size: 1.4rem;
      background-color: transparent;
      color: #767676;

      .icon {
        margin-right: 1.6rem;
        position: relative;
        top: 4px;
        font-size: 1.6rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/app-list/empty-app-list/EmptyAppList.vue?5deb1b0d